// Avisos y confirmaciones con el estilo de la app, en lugar de alert() y confirm()
// del navegador. Los dibujan AvisosDeError y Confirmacion (montados en App.js).

export const EVENTO_AVISO = "aviso";
export const EVENTO_CONFIRMAR = "confirmar";

// tipo: "exito" (algo salió bien), "error" (algo falló) o "info" (p. ej. un dato que falta).
export function avisar(texto, tipo = "info") {
  window.dispatchEvent(new CustomEvent(EVENTO_AVISO, { detail: { texto, tipo } }));
}

let hayVentanaDeConfirmacion = false;
export function registrarVentanaDeConfirmacion(activa) {
  hayVentanaDeConfirmacion = activa;
}

// Pregunta antes de una acción (p. ej. eliminar). Devuelve una promesa con true o false.
// Sin la ventana montada (pruebas de una pantalla suelta) usa confirm() del navegador.
export function confirmar(mensaje, { titulo = "¿Estás seguro?", aceptar = "Confirmar", peligro = true } = {}) {
  if (!hayVentanaDeConfirmacion) return Promise.resolve(window.confirm(mensaje));
  return new Promise((resolver) => {
    window.dispatchEvent(new CustomEvent(EVENTO_CONFIRMAR, { detail: { mensaje, titulo, aceptar, peligro, resolver } }));
  });
}
